import React, { Component } from "react";

import { Item, Button, Icon } from "semantic-ui-react";

import * as moment from "moment";

import { connect } from "react-redux";

import {
  requestOpenReimbursementModal,
  performReimbursementAction
} from "../actions/reimbursements";

const ReimbursementItemImageStyle = imageUrl => ({
  backgroundColor: "gray",
  backgroundImage: "url('" + imageUrl + "')",
  backgroundPosition: "center",
  backgroundSize: "cover",
  width: "100%",
  height: "100%"
});

class PendingReimbursementItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false
    };
  }

  performAction = action => {
    this.setState({
      submitting: action
    });
    performReimbursementAction(this.props.reimbursement, action).catch(
      error => {
        this.setState({
          submitting: false
        });
        console.log(error);
      }
    );
  };

  reject = event => {
    event.stopPropagation();
    this.performAction("reject");
  };

  approve = event => {
    event.stopPropagation();
    this.performAction("approve");
  };

  openModal = () => {
    this.props.requestOpenModal(this.props.reimbursement.uuid);
  };

  render() {
    const reimbursement = this.props.reimbursement;
    return (
      <Item onClick={this.openModal}>
        <Item.Image size="small" rounded onClick={this.openModal}>
          <div
            style={ReimbursementItemImageStyle(reimbursement.image_thumbnail)}
          />
        </Item.Image>

        <Item.Content onClick={this.openModal}>
          <Item.Header as="a">{reimbursement.description}</Item.Header>
          <Item.Meta>${(+reimbursement.amount).toFixed(2)}</Item.Meta>
          <Item.Description>{reimbursement.submitter.name}</Item.Description>
          <Item.Extra>
            {moment(reimbursement.last_action_at).calendar()}
            <Button.Group floated="right">
              <Button
                basic
                positive
                disabled={!!this.state.submitting}
                loading={this.state.submitting === "approve"}
                onClick={this.approve}
              >
                Approve &nbsp; <Icon name="check" />
              </Button>
              <Button
                basic
                negative
                disabled={!!this.state.submitting}
                loading={this.state.submitting === "reject"}
                onClick={this.reject}
              >
                Reject &nbsp; <Icon name="times" />
              </Button>
            </Button.Group>
          </Item.Extra>
        </Item.Content>
      </Item>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  requestOpenModal: reimbursementUUID =>
    dispatch(requestOpenReimbursementModal(reimbursementUUID))
});

export default connect(
  null,
  mapDispatchToProps
)(PendingReimbursementItem);
export { ReimbursementItemImageStyle };



// WEBPACK FOOTER //
// ./frontend/src/components/PendingReimbursementItem.js